import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
    <path
      fill="#000"
      d="M10.417 16.25h1.166v-4.667h4.667v-1.166h-4.667V5.75h-1.166v4.667H5.75v1.166h4.667v4.667zm.587 5.25c-1.452 0-2.817-.276-4.095-.827a10.61 10.61 0 01-3.336-2.243 10.6 10.6 0 01-2.246-3.333A10.212 10.212 0 01.5 11.004c0-1.452.276-2.817.827-4.095A10.61 10.61 0 013.57 3.573a10.6 10.6 0 013.333-2.246A10.212 10.212 0 0110.996.5c1.452 0 2.817.276 4.095.827a10.61 10.61 0 013.336 2.243 10.599 10.599 0 012.246 3.333c.551 1.277.827 2.641.827 4.093s-.276 2.817-.827 4.095a10.61 10.61 0 01-2.243 3.336 10.6 10.6 0 01-3.333 2.246 10.213 10.213 0 01-4.093.827zM11 20.333c2.606 0 4.813-.904 6.62-2.712 1.81-1.808 2.713-4.015 2.713-6.621 0-2.606-.904-4.813-2.712-6.62C15.813 2.57 13.606 1.666 11 1.666c-2.606 0-4.813.904-6.62 2.712C2.57 6.188 1.666 8.394 1.666 11c0 2.606.904 4.813 2.712 6.62 1.809 1.81 4.015 2.713 6.621 2.713z"
    ></path>
  </svg>
);

export default Icon;
